import { z } from 'zod';
import { fleetRecoveryDeviceIdSchema, fleetRecoveryIdSchema, fleetRecoverySha256Schema, fleetRecoveryUtcSchema,
  fleetRecoveryUuidSchema, fleetRecoverySignatureSchema } from '../fleetRecoverySchemas';
export const RECOVERY_CHALLENGE_ADMISSION_DOMAIN = 'playcast-recovery-v3-challenge-admission';
export const recoveryChallengeAdmissionV3Schema = z.object({ domain: z.literal(RECOVERY_CHALLENGE_ADMISSION_DOMAIN),
  deviceId: fleetRecoveryDeviceIdSchema, keyId: fleetRecoveryIdSchema, requestSha256: fleetRecoverySha256Schema,
  issuedAtUtc: fleetRecoveryUtcSchema, clientNonce: fleetRecoveryUuidSchema, signature: fleetRecoverySignatureSchema }).strict();
export type RecoveryChallengeAdmissionV3 = z.infer<typeof recoveryChallengeAdmissionV3Schema>;
